//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from "firebase/app";
import "firebase/auth"; // for authentication
import "firebase/storage"; // for storage
import "firebase/database"; // for realtime database
import "firebase/firestore"; // for firestore
import SettingListCard from "@/modules/setting/components/setting-list-card.vue";
import { mapActions } from "vuex";
export default {
  name: "app-setting-list-table",
  data() {
    return {
      successDialog: false,
      // jobsCount: 0,
      // prescriptionsCount: 0,
      // propertiesCount: 0,
    };
  },

  components: {
    [SettingListCard.name]: SettingListCard,
  },
  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
    async loadPackages() {
      try {
        const db = firebase.firestore();

        // Load monthly package
        const monthlyDoc = await db
          .collection("settings")
          .doc("packageMonthly")
          .get();
        let monthlyData;
        if (monthlyDoc.exists) {
          monthlyData = monthlyDoc.data();
          console.log("Loaded monthly package:", monthlyData);
        } else {
          // Create default monthly package if it doesn't exist
          monthlyData = {
            id: "packageMonthly",
            price: 300,
            nestedPrice: 400,
            type: "Monthly",
          };
          await db
            .collection("settings")
            .doc("packageMonthly")
            .set(monthlyData);
          console.log("Created default monthly package");
        }

        // Load yearly package
        const yearlyDoc = await db
          .collection("settings")
          .doc("packageYearly")
          .get();
        let yearlyData;
        if (yearlyDoc.exists) {
          yearlyData = yearlyDoc.data();
          console.log("Loaded yearly package:", yearlyData);
        } else {
          // Create default yearly package if it doesn't exist
          yearlyData = {
            id: "packageYearly",
            price: 1200,
            nestedPrice: 2000,
            type: "Yearly",
          };
          await db.collection("settings").doc("packageYearly").set(yearlyData);
          console.log("Created default yearly package");
        }

        const packagesData = {
          monthly: monthlyData,
          yearly: yearlyData,
        };

        this.setPackages(packagesData);
        console.log("Updated store with packages:", packagesData);
      } catch (error) {
        console.error("Error loading packages:", error);
        this.setPackages(null);
      }
    },
    ...mapActions({
      setPrescriptionMaxCount: "setting/list/setPrescriptionMaxCount",
      setJobMaxCount: "setting/list/setJobMaxCount",
      setPropertyMaxCount: "setting/list/setPropertyMaxCount",
      setPrescriptionExpirationDays:
        "setting/list/setPrescriptionExpirationDays",
      setPackages: "setting/list/setPackages",
    }),
  },
  async created() {
    await firebase
      .database()
      .ref("setting/prescription")
      .on("value", (snapshot) => {
        this.setPrescriptionMaxCount(snapshot.val());
        // console.log('prescriptionMaxCount',this.prescriptionMaxCount);
        // this.prescriptionsCount = snapshot.val()
        // this.offersLoading = false
        // realtimeValue = snapshot.val()
      });
    await firebase
      .database()
      .ref("setting/job")
      .on("value", (snapshot) => {
        this.setJobMaxCount(snapshot.val());
        // console.log('jobMaxCount',this.jobMaxCount);
        // this.jobsCount = snapshot.val()
        // this.offersLoading = false
        // realtimeValue = snapshot.val()
      });
    await firebase
      .database()
      .ref("setting/property")
      .on("value", (snapshot) => {
        this.setPropertyMaxCount(snapshot.val());
        // console.log('setPropertyMaxCount',this.propertyMaxCount);
        // this.propertiesCount = snapshot.val()
        // this.offersLoading = false
        // realtimeValue = snapshot.val()
      });

    await firebase
      .database()
      .ref("setting/prescriptionExpirationDays")
      .on("value", (snapshot) => {
        this.setPrescriptionExpirationDays(snapshot.val());
        // console.log('setPropertyMaxCount',this.propertyMaxCount);
        // this.propertiesCount = snapshot.val()
        // this.offersLoading = false
        // realtimeValue = snapshot.val()
      });

    // Load packages from Firestore
    await this.loadPackages();
  },
};
